import {createContext} from "react";
import {EntrySettingsProps} from "../Pages/AdminCalendarEntry/Components/Admin/Settings/EntrySettings";

export const CalendarEntrySettingsContext = createContext<EntrySettingsProps>({
    showEditButtons: false,
    showStaffDetails: false
});
